import { useCallback } from 'react'
import { usePhotoPreparer, type PreparedPhoto } from './photo-file'

/**
 * Da escolha do arquivo ao envio: prepara cada foto (RN-PLA-16) e entrega a quem envia, uma por
 * vez; o que a preparação recusa vira a frase de causa e caminho no lugar que a tela disser.
 */
export function usePhotoCapture() {
  const prepare = usePhotoPreparer()
  return useCallback(
    async (
      files: File[],
      send: (photo: PreparedPhoto, file: File) => Promise<void>,
      refuse: (message: string, file: File) => void,
    ) => {
      for (const file of files) {
        const result = await prepare(file)
        if (!result.ok) refuse(result.message, file)
        else await send(result.photo, file)
      }
    },
    [prepare],
  )
}
